import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';

const NewsletterTestPage = lazy(() => import('@/pages/workspaces/broadcasts/newsletter/overview/test/index.page'));

function NewsletterTestRoute() {
  const { newsletterId } = Route.useParams();
  return (
    <Suspense fallback={<PageLoader label="Loading…" />}>
      <NewsletterTestPage key={newsletterId} newsletterId={newsletterId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/test',
)({ component: NewsletterTestRoute });
